import React from 'react';
import { FilterType } from '../../model/FilterType';

const TypeFilter = ({ type, showZones, onChange }: Props) => {
  return (
    <div className="border-bottom w-100">
      <button type="button" className={`btn btn-label-secondary bg-white waves-effect me-2 mb-2 ${type === FilterType.all ? 'active' : ''}`} onClick={() => onChange(FilterType.all)}>
        <span className="ti ti-xs ti-circles"></span>
        <span className="ms-2">All</span>
      </button>
      <button type="button" className={`btn btn-label-secondary bg-white waves-effect me-2 mb-2 ${type === FilterType.location ? 'active' : ''}`} onClick={() => onChange(FilterType.location)}>
        <span className="ti ti-xs ti-location"></span>
        <span className="ms-2">Location</span>
      </button>
      <button type="button" className={`btn btn-label-secondary bg-white waves-effect me-2 mb-2 ${type === FilterType.installation ? 'active' : ''}`} onClick={() => onChange(FilterType.installation)}>
        <span className="ti ti-xs ti-rotate-dot"></span>
        <span className="ms-2">Installation</span>
      </button>
      <button type="button" className={`btn btn-label-secondary bg-white waves-effect mb-2 ${type === FilterType.campaign ? 'active' : ''}`} onClick={() => onChange(FilterType.campaign)}>
        <span className="ti ti-xs ti-device-analytics"></span>
        <span className="ms-2">Campaign</span>
      </button>
      {showZones ? <button type="button" className={`btn btn-label-secondary bg-white waves-effect mb-2 ${type === FilterType.zone ? 'active' : ''}`} onClick={() => onChange(FilterType.zone)}>
          <span className="ti ti-xs ti-map-pin"></span>
          <span className="ms-2">Zone</span>
        </button> : ''}
    </div>
  );
}

interface Props {
  type: FilterType,
  showZones: boolean,
  onChange: (type: FilterType) => void
}

export { TypeFilter };
